import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';

import { ChartType } from '@legacy-modules/metrics2/models/enumerations/ChartType';
import ValueExpression from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';

const label = 'Benachrichtigungen nach Art';
const key = 'finished_deliveries.notifications.by_type';

const getConfig = (category) => {
  return {
    identifier: `${key}.${category.key}`,
    label: category.label,
    longLabel: `${label} (${category.label})`,
    chart: ChartType.bar,
    positiveDirection: PositiveDirection.custom,
    category: 'deliveries',
    description: '<p>Anzahl aller auf Tour angefallenen Benachrichtigungen nach Art (BNK, Email)</p>\n',
    hidden: true,
  };
};

const categories = {
  card: 'BNK',
  email: 'Email',
};

const children = Object.entries(categories).map((category) => {
  const [key, label] = category;
  return new ValueExpression(getConfig({ key: key, label: label }));
});

export default new ValueExpression({
  ...getConfig({ key: 'sum', label: '' }),
  label: label,
  longLabel: label,
  chart: ChartType.line,
  hidden: false,
  children: children,
});
